// extracted by mini-css-extract-plugin
module.exports = {"root":"Pill_root__HirbJ","symbol":"Pill_symbol__ECd92"};